import { connectRefinementList } from 'instantsearch.js/es/connectors'
import trainingSearch from './trainingSearch'

let initialTrainingModalities = null
let initialTrainingDiplomas = null
let initialDaysCount = null
let isInit = false
let eventName = ''

const renderRefinementList = (renderOptions, isFirstRender) => {
  const { items, refine, createURL, widgetParams, instantSearchInstance } = renderOptions

  const urlParams = new URLSearchParams(window.location.search)
  const themeInUrl = urlParams.get('theme')

  let itemsList = items

  if (isFirstRender) {
    const ul = document.createElement('ul')
    ul.classList.add('lg:flex')
    ul.classList.add('flex-wrap')
    ul.classList.add('w-full')
    ul.classList.add('lg:py-4')
    widgetParams.container.appendChild(ul)

    switch (widgetParams.content) {
      case 'project':
        eventName = 'nos-projets-filtre-'
        break
      case 'actuality':
        eventName = 'actualites-filtre-'
        break
      case 'event':
        eventName = 'evenements-filtre-'
        break
      case 'actuality-project':
        eventName = 'des-nouvelles-de-nos-projets-filtre-'
        break
      case 'press':
        eventName = 'press-filtre-'
        break
    }
  } else {
    if (widgetParams.attribute === 'training_modality') {
      if (initialTrainingModalities === null) {
        if (itemsList.length > 2) {
          [itemsList[1], itemsList[2]] = [itemsList[2], itemsList[1]]
        }
        initialTrainingModalities = itemsList
      } else {
        itemsList = initialTrainingModalities
      }
    } else if (widgetParams.attribute === 'training_diploma') {
      if (initialTrainingDiplomas === null) {
        itemsList = itemsList.filter(item => item.label === 'Certification' || item.label === 'Qualification')
        initialTrainingDiplomas = itemsList
      } else {
        itemsList = initialTrainingDiplomas
      }
    } else {
      if (initialDaysCount === null) {
        initialDaysCount = itemsList
      } else {
        itemsList = initialDaysCount
      }
    }

    if (!isInit) {
      // if coming back from single page, re-apply previous filters + searchbox
      if (sessionStorage.getItem('prevUrl').includes('/formations/') && sessionStorage.getItem('currentUrl').includes('/formations')) {
        if (sessionStorage.getItem('filters')) {
          if (!themeInUrl) {
            trainingSearch.applyFilters(instantSearchInstance, JSON.parse(sessionStorage.getItem('filters')))
          }

          sessionStorage.removeItem('filters')
        }

        if (sessionStorage.getItem('querySearchBox')) {
          if (!themeInUrl) {
            instantSearchInstance.renderState[`${instantSearchInstance.indexName}`].searchBox.refine(sessionStorage.getItem('querySearchBox'))
          }

          sessionStorage.removeItem('querySearchBox')
        }
      }
    }

    isInit = true
  }

  itemsList.forEach((item) => {
    const realItem = items.filter((obj) => obj.label === item.label)
    if (realItem[0]) {
      item.isRefined = realItem[0].isRefined
    } else {
      item.isRefined = false
    }
  })

  widgetParams.container.querySelector('ul').innerHTML = itemsList.map((item) => `
    <li class="filters__check ${widgetParams.attribute === 'training_diploma' ? 'filters__check--certif' : ''}">
      <a class="filters__check-link ${
        item.isRefined ? 'is-active' : ''
      }" href="${createURL(item.value)}" data-value="${item.value}">
        ${item.label}
      </a>
      ${item.label === 'Hybride'
          ? `
          <div class="relative inline-block tooltip-wrap">
            <svg class="icon-info" width="20" height="20">
              <use href="#icon-info" xlink:href="#icon-info"></use>
            </svg>
            <div class="tooltip tooltip--top">
              <p class="paragraph">${widgetParams.attribute === 'eventType' ? config.trads['filter.events.hybride'] : 'Alternance de séquences distancielles et présentielles'}</p>
            </div>
          </div>`
          : ''
        }
    </li>`).join('')

  widgetParams.container.querySelectorAll('a').forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault()
      const currentValue = event.currentTarget.dataset.value
      refine(currentValue)

      setTimeout(() => {
        const currentRefinements = instantSearchInstance.renderState[`${instantSearchInstance.indexName}`].currentRefinements.items

        currentRefinements.forEach(refinement => {
          const types = ['actuType', 'eventType', 'pressType']
          if (types.includes(refinement.attribute)) {
            const refinements = refinement.refinements.map(item => item.value)

            if (refinements.includes(currentValue)) {
              // eslint-disable-next-line no-undef
              _paq.push(['trackEvent', 'Click', 'Filtres', `${eventName}${refinements.join(',')}`])
            }
          }
        })
      }, 500)
    })
  })
}

const customRefinementList = connectRefinementList(renderRefinementList)

export default customRefinementList
